import { render, staticRenderFns } from "./massiveActivatedMasterItems.vue?vue&type=template&id=6321dac3&"
import script from "./massiveActivatedMasterItems.vue?vue&type=script&lang=js&"
export * from "./massiveActivatedMasterItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports